import React from "react"

// react-bootstrap imports
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { ServiceSection } from "components/ServiceSection"

import * as Links from "constants/links"
import * as sections from "constants/servicosTaxasV2"


export function ServicosScreen()
{
    return (
        <Container className="d-flex flex-column mb-3">
            <h4 className="text-center text-primary">Selecione o serviço para calcular sua taxa* - CTM 2024</h4>
            <h6 className="text-center text-primary">* O valor calculado aqui é uma estimativa e poderá ser ajustado de acordo com os dados do processo</h6>
            <hr className="w-75 align-self-center opacity-100 text-black"/>
            <Row className="d-flex flex-wrap">
                {sections.SERVICOSTAXAS.map(sec => <Col key={sec.tipoServico}><ServiceSection data={sec} destiny={Links.CALCULAR_TAXAS_CTM24} /></Col>)}
            </Row>
        </Container>
    )
}